import React, { useState } from 'react';

// --- Emoji flag support detection (runs once, cached in sessionStorage) ---
export const checkEmojiFlagSupport = () => {
  const CACHE_KEY = 'emoji_flag_support';
  try {
    const cached = sessionStorage.getItem(CACHE_KEY);
    if (cached !== null) return cached === '1';
    
    const canvas = document.createElement('canvas');
    canvas.width = 10;
    canvas.height = 10;
    const ctx = canvas.getContext('2d');
    if (!ctx) { sessionStorage.setItem(CACHE_KEY, '0'); return false; }
    
    ctx.fillText('\uD83C\uDDEE\uD83C\uDDF3', 0, 10); // 🇮🇳
    const px = ctx.getImageData(0, 0, 10, 10).data;
    
    let isColored = false;
    for (let i = 0; i < px.length; i += 4) {
      if (px[i + 3] > 10 && (px[i] !== px[i + 1] || px[i + 1] !== px[i + 2])) {
        isColored = true;
        break;
      }
    }
    
    sessionStorage.setItem(CACHE_KEY, isColored ? '1' : '0');
    return isColored;
  } catch {
    return false;
  }
};

/**
 * EmojiFlag — renders the emoji flag if the platform supports it,
 * otherwise falls back to the ISO code text (e.g. "IN").
 * Detection is synchronous and cached in sessionStorage.
 */
export const EmojiFlag = React.memo(({ emoji, code }) => {
  const [showEmoji] = useState(() => checkEmojiFlagSupport());
  
  if (showEmoji) {
    return (
      <span style={{ fontSize: '1.15rem', lineHeight: 1, display: 'inline-flex', alignItems: 'center' }}>
        {emoji}
      </span>
    );
  }
  
  return (
    <span style={{ fontSize: '0.78rem', fontWeight: 700, letterSpacing: '0.3px' }}>
      {code}
    </span>
  );
});
